// extracted by mini-css-extract-plugin
module.exports = {"btn":"ThemedButton_btn__86Txa","plusText":"ThemedButton_plusText__isjBR"};